// extracted by mini-css-extract-plugin
export var aside = "ContentBlock-module--aside--aa5eb";
export var asideInner = "ContentBlock-module--asideInner--61b6c";
export var body = "ContentBlock-module--body--98573";
export var bodyInner = "ContentBlock-module--bodyInner--c456e";
export var container = "ContentBlock-module--container--4bc18";
export var hasAside = "ContentBlock-module--hasAside--5e759";